import React from 'react';

const TermsPage: React.FC = () => {
  return (
    <div className="page legal-page">
      <section className="page-heading">
        <div>
          <p className="eyebrow">Terms and conditions</p>
          <h1>Rules for using the Snake Game website.</h1>
          <p>
            These terms are tailored for a modern browser arcade experience with profiles,
            rankings, and social features.
          </p>
        </div>
      </section>

      <section className="legal-grid">
        <article className="legal-card">
          <h2>Use of the site</h2>
          <p>
            You may play the game, browse the pages, and share invite links for personal,
            non-abusive use. Do not attempt to disrupt the site or misrepresent local scores as
            official global rankings.
          </p>
        </article>

        <article className="legal-card">
          <h2>Accounts and profiles</h2>
          <p>
            Registration, sign-in, and profile features are provided to personalize your gameplay
            experience. Keep your account details accurate and do not impersonate other players.
          </p>
        </article>

        <article className="legal-card">
          <h2>Gameplay and rankings</h2>
          <p>
            Leaderboard entries and rankings are part of the competitive experience. Do not abuse
            bugs, automation, or manipulation intended to distort rankings or disrupt fair play.
          </p>
        </article>

        <article className="legal-card">
          <h2>Availability</h2>
          <p>
            The site is provided as-is. Features, visuals, and game rules may change over time as
            the project grows from a simple game into a broader arcade-style experience.
          </p>
        </article>
      </section>
    </div>
  );
};

export default TermsPage;
